/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GroupResponse from './GroupResponse';
import Options from './Options';

/**
* The SearchGroupsResponse model module.
* @module model/SearchGroupsResponse
* @version 2020-12-7
*/
export default class SearchGroupsResponse {
    /**
    * Constructs a new <code>SearchGroupsResponse</code>.
    * グループ検索レスポンス
    * @alias module:model/SearchGroupsResponse
    * @class
    * @param groups {Array.<module:model/GroupResponse>} グループ
    * @param result {module:model/SearchGroupsResponse.ResultEnum} 
    */

    constructor(groups, result) {
        
        
        this['groups'] = groups;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchGroupsResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchGroupsResponse} obj Optional instance to populate.
    * @return {module:model/SearchGroupsResponse} The populated <code>SearchGroupsResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchGroupsResponse();
                        
            
            if (data.hasOwnProperty('groups')) {
                obj['groups'] = ApiClient.convertToType(data['groups'], [GroupResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * グループ
    * @member {Array.<module:model/GroupResponse>} groups
    */
    'groups' = undefined;
    /**
    * @member {module:model/SearchGroupsResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
